import React from "react";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  PauseCircleOutlined,
  ScheduleOutlined,
  SyncOutlined,
} from "@ant-design/icons";

export const statusConfig = {
  confirmed: {
    color: "#1677ff",
    label: "Confirmed",
  },
  planned: {
    color: "#722ed1",
    label: "Planned",
  },
  in_production: {
    color: "#b26a00",
    label: "In Production",
  },
  partially_ready: {
    color: "#faad14",
    label: "Partially Ready",
  },
  ready: {
    color: "#52c41a",
    label: "Ready",
  },
  partially_dispatched: {
    color: "#fa8c16",
    label: "Partially Dispatched",
  },
  dispatched: {
    color: "#8a7a00",
    label: "Dispatched",
  },
  delivered: {
    color: "#389e0d",
    label: "Delivered",
  },
  closed: {
    color: "#595959",
    label: "Closed",
  },
  cancelled: {
    color: "#f5222d",
    label: "Cancelled",
    icon: <CloseCircleOutlined />,
  },
  on_hold: {
    color: "#cf1322",
    label: "On Hold",
    icon: <PauseCircleOutlined />,
  },
  created: {
    color: "#8c8c8c",
    label: "Created",
    icon: <ClockCircleOutlined />,
  },
  scheduled: {
    color: "#531dab",
    label: "Scheduled",
    icon: <ScheduleOutlined />,
  },
  in_progress: {
    color: "#eb2f96",
    label: "In Progress",
    icon: <SyncOutlined spin />,
  },
  paused: {
    color: "#ad6800",
    label: "Paused",
    icon: <PauseCircleOutlined />,
  },
  completed: {
    color: "#237804",
    label: "Completed",
    icon: <CheckCircleOutlined />,
  },
};

export const getStatusConfig = (status) =>
  statusConfig[status] || {
    color: "default",
    label: status || "Unknown",
  };
